// removed by extract-text-webpack-plugin
module.exports = {"container":"_2Zi3o","buttonContainer":"_1ZAT1","button":"_1By31","likeCount":"_1g70M","icon":"_2AirV"};


//////////////////
// WEBPACK FOOTER
// ./app/components/post-main-actions/post-main-actions.scss
// module id = 1714
// module chunks = 0